<div class="d-flex flex-column align-items-center main-container">
  <h3 class="event-name">{{ eventName }}</h3>
  <p class="dashboard-title">Financial dashboard</p>

  <div class="dashboard-container">
    <div class="d-flex flex-wrap w-100 justify-content-center card-wrapper">
      <ngx-gross-sales-card class="flex-grow-1" *ngIf="dashboardData" [currencySlug]="currencySlug" [dashboardData]="dashboardData"></ngx-gross-sales-card>
      <ngx-sold-products-card class="flex-grow-1" *ngIf="dashboardData" [currencySlug]="currencySlug" [dashboardData]="dashboardData"></ngx-sold-products-card>
      <div class="payment-methods-card-wrapper1 flex-grow-1">
        <ngx-payment-methods-card class="w-100" *ngIf="dashboardData" [currencySlug]="currencySlug" [dashboardData]="dashboardData"></ngx-payment-methods-card>
      </div>
    </div>
    <div class="w-100" *ngIf="(dashboardData && dashboardData.products && dashboardData.products.length > 0) || dashboardData?.forms">
      <ngx-products *ngIf="dashboardData" [dashboardData]="dashboardData"></ngx-products>
    </div>

    <div class="payment-methods-card-wrapper2 align-self-center flex-grow-1">
      <ngx-payment-methods-card class="w-100" *ngIf="dashboardData" [currencySlug]="currencySlug" [dashboardData]="dashboardData"></ngx-payment-methods-card>
    </div>
  </div>
</div>
